import { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import AddCategory from "../../Modals/addCategory";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate } from "react-router-dom";

const CategoryList = () => {

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleCloseModal = () => {
    setOpen(false);
  };

  const rows = [
    { id: 1, name: "For Men", date: "01 March 2025" },
    { id: 2, name: "For Women", date: "01 March 2025" }
  ];

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Category Name</TableCell>
              <TableCell>Sub Categories</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <div className="user_block">
                    <figure className="no_radius">
                      <img src="/static/images/placeholder.png" alt="Edit" />
                    </figure>
                    <p><b>{row.name}</b></p>
                  </div>
                </TableCell>
                <TableCell><Button className="btn btn_primary sm" onClick={() => navigate('/manage-service-categories/sub-categories')}>View (4)</Button></TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell><SwitchToggle /></TableCell>
                <TableCell>
                  <Box className="table_actions v2">
                    <IconButton onClick={() => setOpen(true)}>
                      <img src="/static/images/edit2_icon.svg" alt="Edit" />
                    </IconButton>
                    <IconButton>
                      <img src="/static/images/trash2_icon.svg" alt="Delete" />
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <AddCategory open={open} onClose={handleCloseModal} setOpen={setOpen} type="edit" />
    </>
  );
};

export default CategoryList;
